import appConfig from "configs/app";

const DEFAULT_SOCKET_PORTS = new Map([
  ["ws:", "80"],
  ["wss:", "443"],
]);

function normalizeSocketEndpoint(rawEndpoint: string) {
  if (!rawEndpoint) {
    return rawEndpoint;
  }

  try {
    const baseOrigin =
      typeof window !== "undefined"
        ? window.location.origin
        : "http://localhost";
    const parsed = new URL(rawEndpoint, baseOrigin);

    if (parsed.protocol === "wss:" && parsed.port === "80") {
      parsed.protocol = "ws:";
      parsed.port = "";
    }
    const defaultPort = DEFAULT_SOCKET_PORTS.get(parsed.protocol);

    if (defaultPort && parsed.port === defaultPort) {
      parsed.port = "";
    }

    let normalized = parsed.toString();
    if (parsed.pathname === "/" && !rawEndpoint.endsWith("/")) {
      normalized = normalized.replace(/\/$/, "");
    }

    return normalized;
  } catch {
    return rawEndpoint;
  }
}

export default function getSocketUrl(config: typeof appConfig = appConfig) {
  const basePath = config.apis.general.basePath ?? "";
  let socketEndpoint = config.apis.general.socketEndpoint;

  if (
    typeof window !== "undefined" &&
    window.location.protocol === "https:" &&
    socketEndpoint.startsWith("ws://")
  ) {
    socketEndpoint = socketEndpoint.replace("ws://", "wss://");
  }

  socketEndpoint = normalizeSocketEndpoint(socketEndpoint);

  return `${socketEndpoint}${basePath}/socket/v2`;
}
